__turbopack_context__.v({
  "card": "Bento-module__tI8H-W__card",
  "cardSubtitle": "Bento-module__tI8H-W__cardSubtitle",
  "cardTitle": "Bento-module__tI8H-W__cardTitle",
  "grid": "Bento-module__tI8H-W__grid",
  "text": "Bento-module__tI8H-W__text",
});
